<section class="content">
    <div *ngFor="let project of projects" class="row project-container">
        <div class="col">
            <h5>{{project.name}}</h5>
            <small class="text-muted">{{project.description}}</small>            
        </div>
        <div class="col" *ngIf="project.startTime==null && project.endTime==null">Unknown start or end dates</div>
        <div class="col" *ngIf="project.startTime!=null && project.endTime==null">Started {{project.startTime | date: 'M/d/yyyy'}}</div>
        <div class="col" *ngIf="project.startTime==null && project.endTime!=null && project.status=='COMPLETED'">Ended {{project.endTime | date: 'M/d/yyyy'}}</div>
        <div class="col" *ngIf="project.startTime==null && project.endTime!=null && project.status!='COMPLETED'">Ending {{project.endTime | date: 'M/dd/yyyy'}}</div>
        <div class="col" *ngIf="project.startTime!=null && project.endTime!=null && project.status=='COMPLETED'">{{project.startTime | date: 'M/dd/yyyy'}} - {{project.endTime | date: 'M/d/yyyy'}}</div>
        <div class="col" *ngIf="project.startTime!=null && project.endTime!=null && project.status!='COMPLETED'">{{project.startTime | date: 'M/d/yyyy'}} - <i>{{project.endTime | date: 'M/d/yyyy'}}</i></div>
        <div class="col">
            {{project.status}}
        </div>
        <div class="col">
            <div>
                <button class="btn btn-primary me-3 mt-2 disabled" disabled="disabled" title="Editing is not yet available"><i class="fas fa-edit me-2"></i>Edit Project</button>
                <button *ngIf="project.status=='IN PROGRESS' && !updatingStatus" type="button" class="btn btn-danger mt-2" (click)="complete(project.id)"><i class="fas fa-stop me-2"></i>Complete Project</button>
                <button *ngIf="project.status!='IN PROGRESS' && !updatingStatus" type="button" class="btn btn-success mt-2" (click)="start(project.id)"><i class="fas fa-play me-2"></i>Start Project</button>
                <button *ngIf="updatingStatus" type="button" class="btn disabled">Updating...</button>
            </div>
            <div>
                <small class="text-muted">Changing a project status takes time to update docs and stats.</small>
            </div>
        </div>
    </div>
</section>
